export default __webpack_public_path__ + "static/media/image.15498ff9.png";